import { userStore } from '@/store/user-store';
import useConverter from '@/composables/general/useConverter';
import { watch } from 'vue';
import useLocalCache from '@/composables/general/useLocalCache';

const { toBool } = useConverter();
const { getRedirUrlFromCache, deleteRedirFromCache } = useLocalCache();

/**
 *  Provide auto-redirection after logging in to vote/comment/create thought
 *  the redirect information is saved using `storeRedirUrlInCache(actions, extras)`
 *  It triggers when user object is changed (after logging in)
 */
export default function useThoughtRedirect(
  // Method called when page should be redirected to detail page (3 parameters: thoughtid, topicid, any)
  thoughtDetailRedirFunc: any,
  // Method called when page should open thought create form (no param)
  thoughtCreateRedirFunc: any
) {
  watch(
    () => userStore.getState().user,
    (newUser, oldUser) => {
      if (newUser && !toBool(newUser.virtual)) {
        // User is logged in
        // T22958: Check redirection obj
        const redir = getRedirUrlFromCache();
        if (redir != null && redir.action && redir.action != '') {
          if (redir.action == 'comment-thought') {
            // redirect to thought detail and open the comment form
            thoughtDetailRedirFunc(redir.thoughtid, null, { openCommentForm: true });
          } else if (redir.action == 'thought-vote') {
            // redirect to thought detail
            thoughtDetailRedirFunc(redir.thoughtid, null, {});
          } else if (redir.action == 'create-thought') {
            // open thought create form
            thoughtCreateRedirFunc();
          }
          deleteRedirFromCache();
        }
      }
    }
  );
}
